import { render, staticRenderFns } from "./ModalAddNewManager.vue?vue&type=template&id=261e7d0d&"
import script from "./ModalAddNewManager.vue?vue&type=script&lang=js&"
export * from "./ModalAddNewManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports